import { Card, CardContent, Container, Grid } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import { serverUrl } from 'global/variable'
import React from 'react'

const DasarHukum = () => {
    return (
        <Container sx={{ my: 10 }}>
            <ArgonBox mt={2}>
                <Grid container spacing={2} my={2}>
                    <Grid item xs={12} xl={12}>
                        <ArgonTypography>DASAR HUKUM</ArgonTypography>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mt={2}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} xl={12}>
                                <ArgonBox mb={1}>
                                    <iframe width='100%' height={700} title="Pdf" src={
                                        serverUrl + '/uploads/dasar_hukum/dasar_hukum.pdf'
                                    } />
                                </ArgonBox>
                            </Grid>

                        </Grid>
                    </CardContent>
                </Card>
            </ArgonBox>
        </Container>
    )
}

export default DasarHukum
